"use strict";

/**
 * REST API base a konfigurace odvozená z URL a tříd na body.
 */
(function () {
  const origin = window.location.origin;
  const restBase = origin + "/wp-json/businessinfo/v1";

  window.biRestWhispererUrl = restBase + "/whisperer";

  const bodyCls = document.body.className || "";
  const postIdMatch = bodyCls.match(/(?:^|\s)postid-(\d+)(?:\s|$)/);
  const postId = postIdMatch ? parseInt(postIdMatch[1], 10) : 0;

  const archiveVerticalMatch = bodyCls.match(/(?:^|\s)bi-vertical-postid-(\d+)(?:\s|$)/);
  const organizaceArchiveVerticalId = archiveVerticalMatch ? parseInt(archiveVerticalMatch[1], 10) : 0;

  const isOrganizaceArchive = document.body.classList.contains("post-type-archive-organizace_business");
  const isOrganizaceAsVertical = isOrganizaceArchive && organizaceArchiveVerticalId > 0;
  const relatedContentContextPostId = isOrganizaceAsVertical ? organizaceArchiveVerticalId : postId;

  const isSingularOrFrontPage =
    document.body.classList.contains("single") ||
    document.body.classList.contains("page") ||
    document.body.classList.contains("home");

  if (isSingularOrFrontPage || isOrganizaceAsVertical) {
    window.biRelatedContentRestUrl = restBase + "/related-content";
    window.biRelatedContentPostId = relatedContentContextPostId;
    window.biRestSimilarContentUrl = restBase + "/similar-content";
    window.biRestRightWidgetUrl = restBase + "/right-widget";
    window.biRestVideoUrl = restBase + "/video";
    window.biRestCustomPostsUrl = restBase + "/custom-posts";

    /** Číslo stránky článku po <!--nextpage--> (třídy single-paged-N / page-paged-N). */
    let contentPage = 1;
    let cm = bodyCls.match(/(?:^|\s)single-paged-(\d+)(?:\s|$)/);
    if (cm) {
      contentPage = parseInt(cm[1], 10);
    } else {
      cm = bodyCls.match(/(?:^|\s)page-paged-(\d+)(?:\s|$)/);
      if (cm) {
        contentPage = parseInt(cm[1], 10);
      }
    }
    window.biRelatedContentPage = contentPage;
  }

  const isVerticalList = document.body.classList.contains("single-vertical");
  const isFrontPage =
    document.body.classList.contains("home") ||
    (window.location.pathname === "/" || window.location.pathname === "");

  const verticalListPostId = isOrganizaceAsVertical ? organizaceArchiveVerticalId : postId;
  const whispererContextOverride = window.biWhispererContextOverride;
  const filterContextOverride = window.biFilterContextOverride;

  window.biWhispererContext = whispererContextOverride ||
    (isVerticalList || isOrganizaceAsVertical
      ? { context: "vertical", vertical_id: verticalListPostId }
      : { context: "homepage" });

  if (isVerticalList || isFrontPage || isOrganizaceAsVertical) {
    window.biRestFilterUrl = restBase + "/filter";
    window.biRestListUrl = restBase + "/list";
    window.biFilterContext = filterContextOverride ||
      (isVerticalList || isOrganizaceAsVertical
        ? { context: "vertical", vertical_id: verticalListPostId }
        : { context: "homepage" });
    // PHP owns the feed vs filter split (homepage.php sets biListContext).
    window.biListContext = window.biListContext || window.biFilterContext;
  }
})();
